<script>
import {LMarker} from 'vue2-leaflet'
export default {
    extends: LMarker,
    props: {
        id: null
    }
}
</script>